// import React from 'react';
// import { Box, Grid, Typography, Paper } from '@mui/material';
// import news1 from '../assets/image/news1.jpg';
// import news2 from '../assets/image/news2.jpg';

// const NewsGallery = () => {
//     const newsItems = [
//         {
//             title: 'वसतिगृहासाठी प्रवेश प्रक्रिया सुरु',
//             paper: 'लोकमत',
//             date: '21 मे 2025',
//             image: news1,
//         },
//         {
//             title: 'वसतिगृह प्रवेशासाठी पात्र विद्यार्थ्यांनी अर्ज सादर करावेत',
//             paper: 'देशदूत',
//             date: '21 मे 2025',
//             image: news2,
//         },
//     ];

//     return (
//         <Box sx={{ p: 2 }}>
//             <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center' }}>
//                 वर्तमानपत्रातील बातम्या
//             </Typography>

//             <Box sx={{ overflowX: 'auto' }} >
//                 <Grid container spacing={2} wrap="nowrap">
//                     {newsItems.map((item, idx) => (
//                         <Grid item key={idx} sx={{ minWidth: 350 }}>
//                             <Paper elevation={3} sx={{ p: 2 }}>
//                                 <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
//                                     {item.paper} • {item.date}
//                                 </Typography>
//                                 <Typography variant="h6" sx={{ mb: 1 }}>
//                                     {item.title}
//                                 </Typography>
//                                 <Box
//                                     component="img"
//                                     src={item.image}
//                                     alt={item.title}
//                                     sx={{
//                                         width: '100%',
//                                         height: 'auto',
//                                         borderRadius: 1,
//                                         objectFit: 'cover',
//                                     }}
//                                 />
//                             </Paper>
//                         </Grid>
//                     ))}
//                 </Grid>
//             </Box>
//         </Box>
//     );
// };

// export default NewsGallery;


import React from 'react';
import { Box, Grid, Typography, Paper, useMediaQuery, useTheme } from '@mui/material';
import news1 from '../assets/image/news1.jpg';
import news2 from '../assets/image/news2.jpg';

const NewsGallery = () => {
    const newsItems = [
        {
            title: 'वसतिगृहासाठी प्रवेश प्रक्रिया सुरु',
            paper: 'लोकमत',
            date: '21 मे 2025',
            image: news1,
        },
        {
            title: 'वसतिगृह प्रवेशासाठी पात्र विद्यार्थ्यांनी अर्ज सादर करावेत',
            paper: 'देशदूत',
            date: '21 मे 2025',
            image: news2,
        },
    ];

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ p: 2 }}>

            <Typography variant="h6" sx={{ textAlign: "center", color: "#002fa7", fontSize: 25 }}>
                वर्तमानपत्रातील बातम्या
            </Typography>


            {isMobile ? (
                // 👉 Column layout for mobile
                <Grid container spacing={2} direction="column">
                    {newsItems.map((item, idx) => (
                        <Grid item key={idx}>
                            <Paper elevation={3} sx={{ p: 2, mb: 25 }}>
                                <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                    {item.paper} • {item.date}
                                </Typography>
                                <Typography variant="h6" sx={{ mb: 1 }}>
                                    {item.title}
                                </Typography>
                                <Box
                                    component="img"
                                    src={item.image}
                                    alt={item.title}
                                    sx={{
                                        width: '100%',
                                        height: 'auto',
                                        borderRadius: 1,
                                        objectFit: 'cover',
                                    }}
                                />
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                // 👉 Horizontal scroll layout for desktop/tablet
                <Box sx={{ overflowX: 'auto' }}>
                    <Grid container spacing={2} wrap="nowrap">
                        {newsItems.map((item, idx) => (
                            <Grid item key={idx} sx={{ minWidth: 350 }}>
                                <Paper elevation={3} sx={{ p: 2 }} >
                                    <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                        {item.paper} • {item.date}
                                    </Typography>
                                    <Typography variant="h6" sx={{ mb: 1 }}>
                                        {item.title}
                                    </Typography>
                                    <Box
                                        component="img"
                                        src={item.image}
                                        alt={item.title}
                                        sx={{
                                            width: '100%',
                                            height: 'auto',
                                            borderRadius: 1,
                                            objectFit: 'cover',
                                        }}
                                    />
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </Box>
    );
};

export default NewsGallery;
